import React from 'react';
import { Disclosure } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { HashLink as Link } from 'react-router-hash-link';

const navigation = [
  { name: 'Home', href: '/', current: true },
  { name: 'About Us', href: '/about', contentId: 'about', current: false },
  { name: 'Gallery', href: '/gallery', contentId: 'gallery', current: false },
  { name: 'Events', href: '/events', contentId: 'event', current: false },
  { name: 'Take Action', href: '/Donate', contentId: 'Donate', current: false },
  { name: 'Contacts', href: '/contact', contentId: 'contact', current: false },
];

export default function Navbar() {
  return (
    <div className="h-full w-full sticky top-0 z-50">
      <Disclosure as="nav" className="">
        {({ open }) => (
          <>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 bg-slate-200 pb-2.5 shadow-2xl">
              <div className="relative flex h-16 items-center justify-between">
                <div className="absolute inset-y-0 left-0 flex items-center sm:hidden py-2">
                  <Disclosure.Button className="py-1 bg-neutral-200 mx-4 fixed right-0 z-50 rounded-md p-2 text-gray-400 hover:bg-dark hover:text-dark focus:outline-none focus:ring-0 focus:ring-inset focus:ring-dark">
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <Bars3Icon className="block h-7 w-7" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                </div>
                <div className="flex items-center">
                  <img
                    width="120"
                    height="120"
                    className="h-8 w-auto"
                    src="images/logo1.png"
                    alt="Your Company"
                  />

                <div className="mx-2  px-1 ">
                    <h4 className="text-dark text-xl  font-heading pt-3.5 ">Balozi Wa Amani</h4>
                    <span className="mx-4 text-dark text-lg text-center font-heading ">Initiative</span>
                  </div>
                </div>

                <div className="hidden sm:block">
                  <div className="flex justify-end space-x-4">
                    {navigation.map((item) => (
                      <Link
                        smooth
                        to={item.href}
                        scroll={(el) => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                        className="transition duration-150 ease-in delay-150 text-red-700  hover:text-black hover:-translate-y-1 hover:scale-110 px-2 py-4  text-2xl font-bold font-heading3 text-decoration-none"
                        aria-current={item.current ? 'page' : undefined}
                        key={item.name}
                      >
                        {item.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <Disclosure.Panel className="py-2.5 sm:hidden fixed right-0 w-60 bg-white shadow-lg flex flex-col justify-center items-center space-y-1">
              {navigation.map((item) => (
                <Link
                  smooth
                  to={item.href}
                  scroll={(el) => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                  className="transition duration-150 ease-in delay-150 text-red-700  hover:text-black hover:-translate-y-1 hover:scale-110 hover:px-4 hover:py-1 rounded-md pb-3 text-lg font-bold text-decoration-none"
                  aria-current={item.current ? 'page' : undefined}
                  key={item.name}
                >
                  {item.name}
                </Link>
              ))}
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
}
